/** Ordinary manual creation intent must never override an edit or inbox carry. */
export function isFreshObservationIntent(search: {
  compose?: "observation";
  source?: "video" | "tactical_board";
  note_id?: number;
  clip_id?: number;
  inbox_capture_id?: string;
}): boolean {
  return search.compose === "observation" && search.source === "tactical_board"
    && search.note_id === undefined && search.clip_id === undefined
    && search.inbox_capture_id === undefined;
}
